module.exports = __webpack_public_path__ + "img/rencai.132e9697.png";